import React, { useEffect } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import apiClient from '../../services/apiClient';

/**
 * This component handles synchronizing the user's profile with the backend
 * (creating/updating the blob record) whenever the user is successfully authenticated.
 */
const UserProfileSync: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    useEffect(() => {
        const isProfileDebug = import.meta.env.VITE_PROFILE_DEBUG === 'true';

        const syncProfile = async () => {
            // Only sync if properly authenticated and have an active account
            if (isAuthenticated && instance.getActiveAccount()) {
                try {
                    if (isProfileDebug) console.log('[UserProfileSync] Syncing user profile...');
                    await apiClient.syncUserProfile();
                    if (isProfileDebug) console.log('[UserProfileSync] Profile sync successful');
                } catch (error) {
                    console.error('[UserProfileSync] Failed to sync user profile', error);
                    // We don't block the UI for this, just log the error
                }
            }
        };

        syncProfile();
    }, [isAuthenticated, instance]);

    // Just render children, this component has no UI
    return <>{children}</>;
};

export default UserProfileSync;
